<template lang="pug">
  div.SearchChartItem
    div.component-title 共检索到
      span {{total}}
      | 个相关图谱
      EchartSankey
</template>

<script>
import EchartSankey from './EchartSankey'
export default {
  components: { EchartSankey },
  name: 'EventItem',
  data () {
    return {
      total: 0
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.component-title {
  font-size: 16px;
  color: #333;
  margin: 30px 0 20px;

  span {
    color: #f87653;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/SearchChartItem/SearchChartItem.vue